module.exports = __webpack_public_path__ + "static/img/3768_phase_function_Paper_PointsHejduk_Prediction.d57e660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3768_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 26Xv
// module chunks = 0